export const APPROVED_FORMULA_BLOCKED_REASON_CODES = Object.freeze([
  'invalid_formula_input',
  'missing_formula_input',
  'missing_governed_evidence',
  'formula_code_missing',
  'formula_not_active',
  'formula_not_bound',
  'unapproved_source_system',
  'dimension_not_declared',
  'missing_period_cells',
  'missing_fx_rates',
  'never_blend_violation',
  'formula_reconciliation_failure',
  'execution_event_conflict',
  'execution_event_missing_for_read_only_evaluation',
] as const);

export type ApprovedFormulaBlockedReasonCode =
  (typeof APPROVED_FORMULA_BLOCKED_REASON_CODES)[number];
